// extracted by mini-css-extract-plugin
module.exports = {"list":"qDLrgY7UViWIK8g_89JTe"};